module.exports = __webpack_public_path__ + "img/virtuaalijono_added.2a876aed.svg";